import './TabsContent.scss'
import template from './TabsContent.vhtml';

export default {
	name: 'TabsContent',
	template: template,
	props: {
		preSelected: {
			type: String,
			default: '',
		},
	},
	data: () => ({
		tabs: [],
		selected: '',
	}),
	methods: {
		selectTab(title = '') {
			if (title.length > 0) this.selected = title;

			this.tabs.forEach((tab) => {
				tab.$data.isSelected = this.selected === tab.title;
			});
		},
	},
	mounted() {
		this.tabs = this.$children;
		if (this.tabs.length > 0) {
			if (this.preSelected !== '') {
				this.selectTab(this.preSelected);
			} else {
				this.selected = this.tabs[0].title;
				this.tabs[0].$data.isSelected = true;
			}
		}
	},
};
